/**
 *  路由组件
 */
import React, { Component } from 'react'
import { Route } from 'react-router-dom'

import Home from '../page/App/Home';
import Menu from '../page/Menu/Menu';
import Role from '../page/Privilege/Role';
import LogManagement from '../page/LogManagement/index';
// import NotFound from '../page/App/common/404';

class Router extends Component {
    constructor(props) {
        super(props);
        this.state={
         
        }
      }
    
    componentDidMount(){
    }
    
    // exact: 表示路由是严格匹配的
    render() {
        return (
            <div>
                {/* <Route exact path='/page/home' component={Home} /> */}
                <Route exact path='/home/menu' component={Menu} />
                <Route exact path='/home/role' component={Role} />
                <Route exact path='/home/log' component={LogManagement} />
                {/* <Route path="*" component={NotFound}/> */}
            </div>
            
        )
    }
}

export default Router;


// WEBPACK FOOTER //
// ./src/router/router.js